import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';
import dayjs from 'dayjs';
import InputsText from '../../../components/inputs/inputs-text';

import isBetween from 'dayjs/plugin/isBetween';

import humanizeDuration from 'humanize-duration';
import eventsApi from '../../../lib/events/events-api';
import meApi from '../../../lib/users/me-api';
import { toast } from 'react-toastify';

dayjs.extend(isBetween)

export default class PopupsNewPassword extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            password: '',
            password_confirmation: '',
            errors: {}
        }
    }

    update() {
        meApi.update({
            password: this.state.password,
            password_confirmation: this.state.password_confirmation
        }, (errors) => {
            this.setState({ errors })
        }).then(() => {
            toast.success('Successfully updated your password', {
                position: toast.POSITION.BOTTOM_CENTER
            });

            this.context.closePopup();
        })
    }

    render() {
        return (
            <Popup>
                <Popup.Header>
                    <Container.Text fontSize="30px" color="#151515">Are you sure you wish to make a new password?</Container.Text>
                </Popup.Header>

                <Popup.Content>
                    <InputsText
                        label="New Password"
                        name="password"
                        value={this.state?.password}
                        onChange={e => this.setState({ password: e.target.value })}
                        errors={this.state.errors?.password}
                        type="password"
                    />

                    <InputsText
                        label="Confirm Your New Password"
                        name="password_confirmation"
                        value={this.state?.password_confirmation}
                        onChange={e => this.setState({ password_confirmation: e.target.value })}
                        errors={this.state.errors?.password_confirmation}
                        type="password"
                    />
                </Popup.Content>

                <Popup.Buttons>
                    <ButtonProceed onClick={this.update.bind(this)}>Confirm</ButtonProceed>
                    <ButtonReturn onClick={this.context.closePopup} rightIcon={<Cross/>}>Return To Booking</ButtonReturn>
                    <ButtonProceed>Contact us to discuss</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
